const LOCAL_API_BASE_URL = "http://localhost:3100";

export function resolvePublicTenantHost(): string {
  const configured = import.meta.env.VITE_PUBLIC_TENANT_HOST?.trim();
  return configured || globalThis.location?.hostname || "localhost";
}

// Subdomínio de marca (#350): `marca.<produto>.lai.ia.br`, um nível abaixo do
// domínio do produto (education, education-dev…). A API vem pela mesma origem,
// via proxy do front; não existe `api-` por marca.
export function isBrandSubdomainHost(hostname: string): boolean {
  if (!hostname.endsWith(".lai.ia.br")) return false;
  const labels = hostname.slice(0, -".lai.ia.br".length).split(".");
  return labels.length === 2 && labels[0] !== "app" && !labels[0].startsWith("api-");
}

function productionApiBaseUrl(hostname: string): string | null {
  if (
    hostname === "education.lai.ia.br" ||
    hostname === "app.education.lai.ia.br" ||
    isBrandSubdomainHost(hostname)
  ) {
    return globalThis.location?.origin ?? "";
  }
  if (hostname.endsWith(".lai.ia.br") && !hostname.startsWith("api-")) {
    return `https://api-${hostname}`;
  }
  return null;
}

export function resolveApiBaseUrl(): string {
  const hostname = globalThis.location?.hostname;
  const production = hostname ? productionApiBaseUrl(hostname) : null;
  if (production) return production.replace(/\/+$/, "");

  const configured = import.meta.env.VITE_API_URL;
  if (configured) return configured.replace(/\/+$/, "");

  return (production ?? LOCAL_API_BASE_URL).replace(/\/+$/, "");
}
